import type { BasicFetch } from '../types/basicFetch';
import { fetchByteRange } from './fetchByteRange';
import type { VirtualSegment } from './mp4Types';

export async function fetchByteArrays(
  fetch: BasicFetch,
  virtualSegment: VirtualSegment,
): Promise<Uint8Array[]> {
  const promises: Promise<Uint8Array>[] = [];

  for (const byteSource of virtualSegment.byteSources) {
    promises.push(fetchByteRange(fetch, byteSource.url, byteSource.inclusiveByteRangeStart, byteSource.exclusiveByteRangeEnd));
  }

  const results = await Promise.all(promises);
  return results;
}
